import AudioRecorder from '@/trio-ui/AudioRecorder';
import Button from '@/trio-ui/Button';
import * as Styles from './SubmittingPreScreening.styles';

export type PreScreeningQuestionType = {
  label: string;
  id: string;
  url?: string;
};

export type SubmittingPreScreeningProps = {
  onSubmitAnswers: (ansers: any[]) => void;
  questions: PreScreeningQuestionType[];
  questionNotAnswered: boolean;
  isLastQuestion: boolean;
  goToNextQuestion: () => void;
  goToPrevQuestion: () => void;
  onSaveAnswer: (event: any) => void;
  onDeleteAnswer: () => void;
  currentQuesiton: number;
  isLastAnswer: boolean;
  hasNotAnswered: boolean;
};

export default function SubmittingPreScreening({
  onSubmitAnswers,
  questions,
  isLastAnswer,
  goToNextQuestion,
  hasNotAnswered,
  goToPrevQuestion,
  onSaveAnswer,
  onDeleteAnswer,
  currentQuesiton,
}: SubmittingPreScreeningProps): JSX.Element {
  return (
    <Styles.Container isSmaller>
      <Styles.Grid>
        <Styles.Sidebar>
          <Styles.SidebarList>
            <Styles.SidebarItem isAnswered>
              <Styles.SidebarQuestion>Welcome</Styles.SidebarQuestion>
              <Styles.SidebarQuestion isMobile>Welcome</Styles.SidebarQuestion>
            </Styles.SidebarItem>
            {questions.map((question, index) => {
              return (
                <Styles.SidebarItem
                  isActived={index === currentQuesiton}
                  isAnswered={index < currentQuesiton}
                  key={index.toString()}
                >
                  <Styles.SidebarQuestion>{question.label}</Styles.SidebarQuestion>
                  <Styles.SidebarQuestion isMobile>Question {index + 1}</Styles.SidebarQuestion>
                </Styles.SidebarItem>
              );
            })}
          </Styles.SidebarList>
        </Styles.Sidebar>
        <Styles.Content>
          {questions.map((question, index) => {
            if (index !== currentQuesiton) {
              return <span key={index.toString()} />;
            }
            return (
              <Styles.QuestionCard key={index.toString()}>
                <Styles.QuestionHeader>
                  <Styles.QuestionText>{question.label}</Styles.QuestionText>
                </Styles.QuestionHeader>
                <Styles.QuestionBody>
                  <AudioRecorder
                    onDeleteAudio={onDeleteAnswer}
                    defaultUrl={question?.url}
                    onExternalSave={onSaveAnswer}
                  />
                </Styles.QuestionBody>
              </Styles.QuestionCard>
            );
          })}

          <Styles.QuestionButtons>
            <Button
              disabled={currentQuesiton === 0}
              onClick={goToPrevQuestion}
              size="medium"
              variantStyle="outline"
            >
              Back
            </Button>
            <Button
              disabled={hasNotAnswered}
              onClick={isLastAnswer ? () => onSubmitAnswers(questions) : goToNextQuestion}
              size="medium"
              variantColor="yellow"
            >
              {isLastAnswer ? 'Submit' : 'Next'}
            </Button>
          </Styles.QuestionButtons>
        </Styles.Content>
      </Styles.Grid>
    </Styles.Container>
  );
}
